import React from "react";
import { Navigate, RouteObject } from "react-router";
import { getFieldsData } from "../../../API/fields";
import Dashboard from "../../../Component/Dashboard/Dashboard";
import DashboardError from "../../../Component/Error/DashboardError";
import FieldPage from "../../../Component/Field/FieldPage";
import field from "./field";
import fields from "./fields";
import taskmap from "./taskmap";
import support from "./support";
import treescout from "./treescout";
import calibrate from "./field/_field_id/result-set/calibrate";

const routes: RouteObject = {
  path: ":customerId",
  Component: Dashboard,
  id: "customer",
  loader: getFieldsData,
  errorElement: React.createElement(DashboardError),
  children: [
    {
      index: true,
      element: React.createElement(Navigate, { to: "field" }),
    },
    taskmap,
    {
      Component: FieldPage,
      children: [fields, field],
    },
    calibrate,
    treescout,
    support,
  ],
};

export default routes;
